/*
  Array map of currencies to sort by in the currency dropdown.
  Add more to this array for custom currency sorting.
*/
export const currencyOrder = ['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'NZD'];

/*
  Avro v4 event name for plan change interactions
*/
export const PLAN_CHANGE_EVENT =
  'schema:billing.account.plan.PlanChangeUserInteractionEvent';
